import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class InvalidCredentialsError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidCredentialsError";
    }
}
export class PasswordRevokedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRevokedError";
    }
}
export class IdentityDisabledError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "IdentityDisabledError";
    }
}
export class InvalidAuthenticationModeError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidAuthenticationModeError";
    }
}
export class MfaRequiredError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "MfaRequiredError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class ConflictError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ConflictError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    InvalidCredentialsError,
    PasswordRevokedError,
    IdentityDisabledError,
    InvalidAuthenticationModeError,
    MfaRequiredError,
    NotFoundError,
    ConflictError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
